export const HEADER_CHARGER_RESPONSE = 0xc0;
export const HEADER_HOLDER_RESPONSE = 0x08;
export const OFFSET_DEVICE_TYPE = 1;
export const OFFSET_APP_LAYER_HEADER = 2;
export const OFFSET_PAYLOAD_START = 4;

export const PLATFORM_CODE_OFFSET = 0;
export const PRODUCT_CODE_OFFSET = 2;
export const SITE_CODE_OFFSET = 4;
export const DEVICE_NUMBER_OFFSET = 6;
export const DEVICE_NUMBER_END = 10;

export const FRAME_CHARGER_CODENTIFY = '00C0000309';
export const FRAME_CHARGER_SERIAL = '00C0010015';
export const FRAME_CHARGER_FIRMWARE = '00C0000000';

export const FRAME_LED_DAY = "00C0462355000000F0";
export const FRAME_LED_NIGHT= "00C046230E00000086";
export const FRAME_LED_SETTINGS = "00C00223C3";

export const FRAME_STOP_VIBRATION = "00C04522001E0000D5";
export const FRAME_START_VIBRATION = "00C04522011E0000C3";